import { render, staticRenderFns } from "./groupGoodsSearch.vue?vue&type=template&id=38fd9869&scoped=true&"
import script from "./groupGoodsSearch.vue?vue&type=script&lang=js&"
export * from "./groupGoodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./groupGoodsSearch.vue?vue&type=style&index=0&id=38fd9869&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd9869",
  null
  
)

export default component.exports